import { render, staticRenderFns } from "./performanceCom.vue?vue&type=template&id=133c7867&"
import script from "./performanceCom.vue?vue&type=script&lang=js&"
export * from "./performanceCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133c7867')) {
      api.createRecord('133c7867', component.options)
    } else {
      api.reload('133c7867', component.options)
    }
    module.hot.accept("./performanceCom.vue?vue&type=template&id=133c7867&", function () {
      api.rerender('133c7867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/performanceCom.vue"
export default component.exports